export default class Ingredient {
    constructor (name, rarity, details, dc, terrains) {
        this.name = name;
        this.rarity = rarity;
        this.details = details;
        this.dc = dc;
        this.terrains = terrains;
    }
}



// WEBPACK FOOTER //
// ./src/controllers/Ingredient.js